/* global Swiper */
// *******************************************************************************
// 1.0 - Hero Slider
// *******************************************************************************

const heroSliderElements = document.querySelectorAll('[data-slider="hero-slider"]');

const heroSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  autoHeight: true,
  watchOverflow: true,
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    1023: {
      autoHeight: false,
    }
  },
};

heroSliderElements.forEach((el) => {
  const heroSliderParent = el.closest('.hero-slider');
  const heroSliderSlides = heroSliderParent.querySelectorAll('.swiper-slide');
  const paginationElement = heroSliderParent.querySelector('.swiper-pagination');

  if (heroSliderSlides.length === 1) {
    heroSliderOptions.autoHeight = false;
    heroSliderOptions.loop = false;
  }

  heroSliderOptions.pagination.el = paginationElement;

  // eslint-disable-next-line no-new
  new Swiper(el, heroSliderOptions);
});
